export default __webpack_public_path__ + "static/Serhii-Trachuk-624641fe7ae0a63e061967282a2d526c.png";